import { Icon, List, Modal, Radio, Text } from "../../../../components";
import Localization from "../../../../localization";
import EditRecipient from "./editRecipient";
import useViewModel from "../../viewModel";
import { useApp } from "../../../../hooks";
import { SVGs } from "../../../../assets";
import { useRef, useState } from "react";
import { Flex } from "antd";

const ModifyRecipient = ({ ...props }) => {
  const [owner, setOwner] = useState(false);
  const isNew = !props.recipient?.id;

  return (
    <>
      {isNew &&
        !props.recipients.find((_) => !!_.owner) &&
        !!props.canBeOwner && (
          <Radio.Group
            value={owner}
            className="m-30-b"
            onChange={(_) => setOwner(_.target.value)}
            options={[
              { label: Localization.general.you, value: true },
              { label: Localization.general.someone_else, value: false },
            ]}
          />
        )}
      <EditRecipient
        {...props}
        isNew={isNew}
        isOwner={owner}
        onSave={(data) =>
          props.onSave({ ...data, id: props.recipient.id, owner })
        }
      />
    </>
  );
};

const Recipients = ({ canBeOwner = true, ...props }) => {
  const { modal } = useApp();
  const modifyContactModalRef = useRef();
  const {
    alarmSMS,
    loadDeviceAlarmRecipient = () => {},
    modifyDeviceAlarmRecipient = () => {},
    removeDeviceAlarmRecipient = () => {},
  } = useViewModel();

  const deleteContact = async (_) => {
    modal.confirm({
      okText: Localization.general.yes,
      cancelText: Localization.general.no,
      title: Localization.service.alarmSMS_modal_del_title,
      description: Localization.formatString(
        Localization.service.alarmSMS_modal_del_desc,
        <Text weight={600} level={"text"} color="inherit" children={_.name} />
      ),
      onOk: async (modal) => {
        await removeDeviceAlarmRecipient(_.id);
        modal.destroy();
      },
    });
  };

  const renderRecipient = (_) => (
    <List.Item
      extra={
        <Flex gap={"2rem"}>
          {!_.owner && (
            <Text level={3} type="secondary">
              <Icon
                onClick={() => modifyContactModalRef.current.open(_)}
                component={SVGs.editOutlinedComp}
              />
            </Text>
          )}
          <Text level={3} type="secondary">
            <Icon
              component={SVGs.deleteOutlinedComp}
              onClick={() => deleteContact(_)}
            />
          </Text>
        </Flex>
      }
      children={
        <List.Item.Meta
          description={_.endpoint}
          title={
            !_.owner ? (
              _.name
            ) : (
              <Flex gap={".5rem"} align="center">
                <SVGs.star />
                <Text
                  level={5}
                  weight={"700"}
                  children={`${_.name} (${Localization.general.owner})`}
                />
              </Flex>
            )
          }
        />
      }
    />
  );

  return (
    <>
      <Flex gap={"2rem"} vertical {...props}>
        <List>
          <List.Item
            onClick={() => modifyContactModalRef.current.open({})}
            children={
              <List.Item.Meta
                title={{
                  type: "secondary",
                  children: Localization.general.add,
                }}
                avatar={
                  <Text level={1}>
                    <Icon component={SVGs.plusHollowCircleFilledComp} />
                  </Text>
                }
              />
            }
          />
        </List>
        {!!alarmSMS.recipients.length && (
          <List
            highlightOnHover={false}
            renderItem={renderRecipient}
            dataSource={alarmSMS.recipients}
            pagination={{
              total: alarmSMS.total,
              onShowLess: () =>
                loadDeviceAlarmRecipient({ limit: 5, offset: 0 }),
              onShowMore: () =>
                loadDeviceAlarmRecipient({
                  limit: 10,
                  offset: alarmSMS.recipients.length,
                }),
            }}
          />
        )}
      </Flex>
      <Modal
        ref={modifyContactModalRef}
        title={(_) =>
          !!_.id
            ? Localization.general.edit_alarm_recipient
            : Localization.general.new_alarm_recipient
        }
        child={(recipient) => (
          <ModifyRecipient
            recipient={recipient}
            canBeOwner={canBeOwner}
            recipients={alarmSMS.recipients ?? []}
            onSave={async (data) => {
              await modifyDeviceAlarmRecipient({ ...data, type: "sms" });
              modifyContactModalRef.current.close();
            }}
          />
        )}
      />
    </>
  );
};

export default Recipients;
